import React from "react";
import classNames from "classnames";
import { Button } from "reactstrap";
import PropTypes from "prop-types";
import styles from "./app-menu-track.module.scss";
import noOp from "lib/no-op";

const AppMenuTrack = ({ ubungen = [], trackId = 0, _onClick = noOp() }) => {
  return (
    <div className={styles.root}>
      <ul>
        {ubungen.map((ubung, i) => {
          const { incrementor, index } = ubung;
          return (
            <li
              key={i}
              className={classNames(
                styles[`level${ubung.level.id}`],
                styles.level
              )}
            >
              <Button
                className={classNames(
                  trackId === incrementor && styles.active,
                  styles.track
                )}
                onClick={() => _onClick(incrementor)}
              >
                <div className={styles.tracknum}>
                  {index}
                </div>
                <div className={styles.tracktitle}>
                  {ubung.title}
                </div>
              </Button>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

AppMenuTrack.defaultProps = {
  ubungen: [],
};

AppMenuTrack.propTypes = {
  ubungen: PropTypes.arrayOf(
    PropTypes.shape({
      index: PropTypes.number.isRequired,
      title: PropTypes.string.isRequired,
      showFreemium: PropTypes.number,
    })
  ),
};
export default AppMenuTrack;
